import { render } from "./Chatbot.vue?vue&type=template&id=bca89894&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"

import "@/assets/Chatbot.css?vue&type=style&index=0&id=bca89894&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca89894"]])

export default __exports__